import styles from "../../styles/NoData.module.css"
import { ReactComponent as Icon } from "../../assets/icons/NoData.svg"

const NoData = ({ icon, title, subTitle }) => {
  const Bubble = ({ size, pos }) => {
    return (
      <div className={styles.atom_orbit}>
        <span
          className={styles.dot}
          style={{
            position: "absolute",
            width: `${size}px`,
            height: `${size}px`,
            bottom: `${pos.y}px`,
            left: `${pos.x}px`,
          }}
        ></span>
      </div>
    )
  }

  return (
    <div className={styles.no_record_div}>
      <div
        style={{
          position: "relative",
          width: "200px",
          height: "150px",
        }}
      >
        <Bubble size="19" pos={{ x: 52, y: 35 }} />
        <Bubble size="22" pos={{ x: 138, y: 92 }} />
        <Bubble size="25" pos={{ x: 40, y: 100 }} />
        <span
          style={{
            height: "75px",
            width: "75px",
            marginTop: "40px",
          }}
          className={styles.dot}
        >
          {icon ? (
            icon
          ) : (
            <div
              style={{
                height: "75px",
                width: "75px",
                position: "absolute",
                top: "55px",
                left: "73px",
                zIndex: 2,
              }}
            >
              <Icon width={75} height={75} />
            </div>
          )}
        </span>
      </div>
      <div className={styles.textWrap}>
        {title && <label className={styles.title}>{title}</label>}
        {subTitle && <label className={styles.subTitle}>{subTitle}</label>}
      </div>
    </div>
  )
}
export default NoData
